import { HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, NgZone } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Storage } from '@ionic/storage';
import _ from 'lodash';
import moment from 'moment';
import { Observable } from 'rxjs';
import { PageAccessible } from '../model/page-builder.model';
import { NestApiProvider } from './../../shared/nestjs/nest-api'; // Need Dependency - PageBuilder
import { LoopBackConfig } from './../../shared/sdk/lb.config'; // Need Dependency - PageBuilder
import { LoopBackAuth } from './../../shared/sdk/services/core/auth.service'; // Need Dependency - PageBuilder
import { BuilderServiceApi } from './../../shared/sdk/services/custom/BuilderService'; // Need Dependency - PageBuilder
import { UploadAttachmentProvider } from './../../providers/upload-attachment/upload-attachment'; // Need Dependency - PageBuilder
import { ApiServiceProvider } from './../services/api/api-service';
import { FileTransferOptions, FileTransferNative } from '../../native/file-transfer.native'; // Need Dependency - PageBuilder
import * as async from 'async';
import { Platform } from "ionic-angular/platform/platform";
import { Response, Page } from '../model/page-builder.model';
import { PageAccessibleService } from '../services/helper/page-accessible.service';

declare var google;

@Injectable()
export class PageBuilderGlobal {

  public pagebuilderBaseUrl = 'https://api.greatdayhr.com/builder/';
  public pagebuilderApiUrl = 'https://api.greatdayhr.com/builder/api/';

  // public pagebuilderBaseUrl = 'http://localhost:3001/';
  // public pagebuilderApiUrl = 'http://localhost:3001/api/';

  // public sfgoApiUrl = 'http://localhost:3000/api/'; //dev
  public sfgoApiUrl = 'https://apigonbc.dataon.com/api/'; //live

  public SFGoAuth: any;
  public SFGoStorage: any;

  public path: any;
  public oldPATHUrl: any;
  public newPATH: boolean = false;
  public newPATHUrl: any;

  constructor(
    private storage: Storage,
    private http: Http,
    private builderServiceApi: BuilderServiceApi,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    private uploadAttachmentProvider: UploadAttachmentProvider,
    private apiServiceProvider: ApiServiceProvider,
    private nestApiProvider: NestApiProvider,
    private fileTransferNative: FileTransferNative,
    private platform: Platform,
    private ngZone: NgZone,
    private pageAccessibleService: PageAccessibleService
  ) {
    this.path = LoopBackConfig.getPath();
    this.getStorage();
  }

  async getStorage() {
    return new Promise(async (resolve) => {
      await this.getStorageSfGoAuth();
      await this.getStorageSfGoStorage();
      resolve(true);
    });
  }

  async getStorageSfGoStorage(): Promise<any> {
    // console.log('TCL:Get Storage');
    return new Promise((resolve) => {
      this.storage.ready().then(() => {
        this.storage.get('SFGoStorage').then(async (hasil) => {
          if (hasil != null && hasil != undefined) {
            this.SFGoStorage = JSON.parse(hasil);
            if (this.SFGoStorage.hasOwnProperty('storedPrelogin') && this.SFGoStorage.storedPrelogin) {
              this.oldPATHUrl = this.SFGoStorage.storedPrelogin.GOPATH;
            } else {
              this.oldPATHUrl = this.path;
            }
            let path;
            if (this.SFGoStorage.hasOwnProperty('storedPrelogin') && this.SFGoStorage.storedPrelogin &&
              this.SFGoStorage.storedPrelogin.hasOwnProperty('GOPATHNEW') && this.SFGoStorage.storedPrelogin.GOPATHNEW) {
              // console.log('TCL:New Path Found');
              this.newPATH = true;
              path = this.SFGoStorage.storedPrelogin.GOPATHNEW;
              this.newPATHUrl = path;
            } else {
              // console.log('TCL:New Path Not Found');
              this.newPATH = false;
            }
            // this.newPATHUrl = 'http://localhost:30000' // local nestjs;
            // this.newPATHUrl = 'http://localhost:5000' // local loopback;
            resolve(true);
          }
        });
      });
    });
  }

  getStorageSfGoAuth(): Promise<any> {
    return new Promise(async (resolve) => {
      this.path = LoopBackConfig.getPath();
      // console.log('TCL: ', this.path);
      this.storage.ready().then(() => {
        this.storage.get('SFGoAuth').then(hasil => {
          if (hasil != null && hasil != undefined) {
            this.SFGoAuth = JSON.parse(hasil);
            resolve(true);
          }
        });
      });
    })
  }

  getStaticMenu(): Promise<any> {
    return new Promise((resolve) => {
      this.storage.ready().then(() => {
        this.storage.get('SFGoAuth').then(hasil => {
          if (hasil != null && hasil != undefined) {
            this.SFGoAuth = JSON.parse(hasil);
            this.http.get('../../assets/pagebuilder/menu/static.json')
              .subscribe((result: any) => {
                let res = result.json();
                for (let index = 0; index < res.length; index++) {
                  // const element = result[index];
                  res[index].companyId == this.SFGoAuth.companyId ? res[index].menuActive = true : res[index].menuActive = false;
                }
                // console.log('TCL:TCL:getStaticMenu', res);
                resolve(res);
              })
          }
        });
      });
    });
  }

  getStaticPage(pageId): Promise<any> {
    return new Promise((resolve) => {
      this.http.get('../../assets/pagebuilder/page/' + pageId + '.json')
        .subscribe((result: any) => {
          // console.log('TCL:TCL:getStaticMenu',);
          resolve(result.json());
        })
    });
  }

  public getAuthData(key): Promise<any> {
    return new Promise((resolve) => {
      resolve(this.SFGoAuth[key]);
    });
  }

  public getSFGoApiUrl(): Promise<any> {

    return new Promise((resolve) => {
      let path = this.oldPATHUrl + '/api/';
      resolve(path);
    })

  }

  public getPageById(pageId): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const urlParams = '&pageId=' + pageId;
      this.apiServiceProvider.apiPB('GET', urlParams, null, '/app-page/getPageById', false, true).then(async (response: Response<Page>) => {
        if (response.data) {
          // console.log('Load Page Success');
          resolve(response.data);
        } else {
          // console.log('Load Page Error');
          reject(false);
        }
      }, error => {
        // console.log('Load Page Error');
        reject(error);
      });
    });
  }

  public getPageSchemaById(pageId): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const urlParams = '&pageId=' + pageId;
      this.apiServiceProvider.apiPB('GET', urlParams, null, '/app-page/getPageById', false, true).then(async (response: Response<Page>) => {
        if (response.data) {
          // console.log('Load Page Success');
          resolve(response.data);
          resolve(JSON.parse(response.data.schema));
        } else {
          // console.log('Load Page Error');
          reject(false);
        }
      }, error => {
        // console.log('Load Page Error');
        reject(error);
      });
    })
  }

  public isPageAccessible(pageId): Promise<any> {
    // console.log('TCL:TCL:trigger is page accessible');
    return new Promise(async (resolve, reject) => {

      let pageBuilderIsPageAccessible;
      pageBuilderIsPageAccessible = await this.storage.get('pageBuilderIsPageAccessible');
      try {
        pageBuilderIsPageAccessible = JSON.parse(pageBuilderIsPageAccessible);
      } catch (e) {
        pageBuilderIsPageAccessible = pageBuilderIsPageAccessible;
      }

      let check = this.checkStorageIsPageAccessible(pageBuilderIsPageAccessible, pageId);
      // console.log('TCL: isPageAccessibleV2', check);

      if (check && check.status) {

        const urlParams = '&pageId=' + pageId;
        this.apiServiceProvider.api('GET', urlParams, null, '/api/BuilderServices/isPageAccessibleV2', '/builder/isPageAccessibleV2', null, true).then((response: PageAccessible) => {
          if (response.data) {
            let result = response.data;
            // console.log('TCL: is page accessible', result);
            if (!pageBuilderIsPageAccessible) pageBuilderIsPageAccessible = {};

            if (pageBuilderIsPageAccessible && !pageBuilderIsPageAccessible[pageId]) {
              // console.log('TCL: is page accessible pageBuilderIsPageAccessible 0');
              this.storageIsPageAccesible(pageId, pageBuilderIsPageAccessible, result);
            }
            resolve(result);
          } else {
            // console.log('Error get isPageAccessible Empty Data');
            resolve(false);
          }
        }, error => {
          // console.log('Error get isPageAccessible', error);
          resolve(false);
        });
      } else if (check && !check.status) {
        resolve(check.result);
      }
    })
  }

  public checkStorageIsPageAccessible(pageBuilderIsPageAccessible, pageId) {
    if (pageBuilderIsPageAccessible && pageBuilderIsPageAccessible[pageId]) {
      let dateNow = new Date();
      // console.log('TCL: ', dateNow);
      // console.log('TCL: ', new Date(find[0].cacheDuration));

      // console.table('find[0]', find[0]);
      if (pageBuilderIsPageAccessible[pageId].cacheDuration && (new Date(pageBuilderIsPageAccessible[pageId].cacheDuration) > dateNow)) {
        // console.log('TCL: checkStorageIsPageAccessible dont check accessible');
        return { status: false, result: pageBuilderIsPageAccessible[pageId].result };
      } else {
        // console.log('TCL: deleted index checkStorageIsPageAccessible');
        delete pageBuilderIsPageAccessible[pageId]
        return { status: true, result: true };
      }
    }
    return { status: true, result: true };
  }

  public isPageAccessibleV2(pageId): Promise<any> {
    // console.log('TCL:TCL:trigger is page accessible');
    if (localStorage.getItem('accessMode') == 'jobseeker') {
      return new Promise(async (resolve, reject) => {
        resolve(true);
      })
    } else {
      return new Promise(async (resolve, reject) => {
        const access = await this.pageAccessibleService.checkAccessible(pageId)
        resolve(access);
        /** uncomment if accessible error */
        // await this.getStorage();
        // // const accessGroup = await this.accessmanagementApi.userAccessGroup().toPromise();
        // const accessGroup = await this.storage.get('userAccessGroup');
        // const accessGroupData = accessGroup ? JSON.parse(accessGroup) : [];
        // const bodyAuth = {
        //     companyId: this.SFGoAuth && this.SFGoAuth.companyId ? this.SFGoAuth.companyId : '',
        //     empId: this.SFGoAuth && this.SFGoAuth.empId ? this.SFGoAuth.empId : '',
        //     userAccess: accessGroupData,
        //     pageId: pageId,
        //     funcAuthMenu: {
        //         menu: this.SFGoAuth.menu,
        //         socket: this.SFGoAuth.socket,
        //     },
        //     functionAuth: this.SFGoAuth.functionAuth,
        // }
        // const urlBody = JSON.stringify(bodyAuth);
        // const encryptedBody = await this.apiServiceProvider.sfEncrypt(urlBody);
        // const body = {
        //     urlBody: encryptedBody,
        // }
        //
        // let pageBuilderIsPageAccessible;
        // pageBuilderIsPageAccessible = await this.storage.get('pageBuilderIsPageAccessible');
        // try {
        //     pageBuilderIsPageAccessible = JSON.parse(pageBuilderIsPageAccessible);
        // } catch (e) {
        //     pageBuilderIsPageAccessible = pageBuilderIsPageAccessible;
        // }
        //
        // let check = this.checkStorageIsPageAccessible(pageBuilderIsPageAccessible, pageId);
        // // console.log('TCL: isPageAccessibleV2', check);
        //
        // if (check && check.status) {
        //
        //     this.apiServiceProvider.apiPB('POST', null, body, '/app-page/isPageAccessibleV2', null, true).then((response: PageAccessible) => {
        //         if (response.data) {
        //             let result = response.data;
        //             // console.log('TCL: is page accessible', result);
        //             if (!pageBuilderIsPageAccessible) pageBuilderIsPageAccessible = {};
        //
        //             if (pageBuilderIsPageAccessible && !pageBuilderIsPageAccessible[pageId]) {
        //                 // console.log('TCL: is page accessible pageBuilderIsPageAccessible 0');
        //                 this.storageIsPageAccesible(pageId, pageBuilderIsPageAccessible, result);
        //             }
        //             resolve(result);
        //         } else {
        //             // console.log('Error get isPageAccessible Empty Data');
        //             resolve(false);
        //         }
        //     }, error => {
        //         // console.log('Error get isPageAccessible', error);
        //         resolve(false);
        //     });
        // } else if (check && !check.status) {
        //     resolve(check.result);
        // }
      })
    }
  }

  storageIsPageAccesible(pageId, pageBuilderIsPageAccessible, result) {
    // console.log('TCL: set storageIsPageAccesible');
    let date = new Date();
    let item = {
      cacheStart: date,
      cacheDuration: new Date(date.setSeconds(date.getSeconds() + 300)),
      result: result,
    }
    pageBuilderIsPageAccessible[pageId] = item;
    this.storage.set('pageBuilderIsPageAccessible', JSON.stringify(pageBuilderIsPageAccessible));
    // console.table('item', pageBuilderIsPageAccessible);
  }

  public async cfcDirectApi(route, param = {}, body = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      // console.log('TCL:TCL:cfcDirectApi', route, param, body);
      const interval = 15 * 60 * 1000;
      this.builderServiceApi.cfcDirect(route, param, body)
        .timeout(interval)
        .subscribe((result) => {
          resolve(result);
        }, error => {
          console.log('TCL:TCL:cfcDirectApi Error', error);
          reject(error);
        });
    })
  }

  public async sfgoDirectApi(route, method, param = null, paramTarget = 'url', data = null, config = null): Promise<any> {
    let setParam = await this.setParam(config, param, paramTarget);
    let setBody = await this.setBody(data, param, paramTarget);

    // console.log('TCL:TCL:setParam', setParam);

    return new Promise((resolve, reject) => {
      this.storage.ready().then(() => {
        this.storage.get('SFGoAuth').then(auth => {
          let SFGoAuth = JSON.parse(auth);

          if (setParam) {
            if (setParam.charAt(0) === '&') {
              setParam = setParam.substr(1, 100000000);
              console.log('slice', setParam);
              const paramsFinal = '?' + setParam;
              setParam = paramsFinal;
              console.log('paramsFinal', paramsFinal);
            }
          }
          let setUri = SFGoAuth.path + '/api/' + route + setParam;

          const headerOptions: Headers = new Headers({
            'Authorization': LoopBackConfig.getAuthPrefix() + SFGoAuth.id,
          });
          const options: RequestOptions = new RequestOptions({ headers: headerOptions });

          if (method == 'GET') {
            this.http.get(setUri, options)
              .map(data => data.json())
              .subscribe((result: any) => {
                resolve(result);
              }, error => {
                reject(error);
              })
          } else if (method == 'POST') {
            this.http.post(setUri, setBody, options)
              .map(data => data.json())
              .subscribe((result: any) => {
                resolve(result);
              }, error => {
                reject(error);
              })
          }

        });
      });
      // resolve(true);
    });
  }


  public downloadFile(func, methodApi, param?, newPath?, bind?): Observable<any> {
    // console.log('TCL: Download File', func, methodApi, param, newPath)
    let path;
    if (newPath !== null) {
      path = this.oldPATHUrl
      if (this.changeURL(newPath)) path = this.newPATHUrl;
    } else {
      path = this.oldPATHUrl
      if (this.newPATHUrl) path = this.newPATHUrl
    }
    // console.log('TCL: Download File Path', path)

    let paramData = '';
    let params: any = {}
    if (param != null) {
      if (methodApi == 'POST') {
        if (param.constructor.name === 'Array') {
          param.forEach(item => {
            params[item.paramKey] = item.paramValue
          })
        } else {
          params = param
        }
      } else if (methodApi == 'GET') {
        if (param.constructor.name === 'Array') {
          param.forEach(element => {
            if (element.paramValue != null && element.paramValue.constructor.name == 'Array') {
              for (let i = 0; i < element.paramValue.length; i++) {
                paramData += '?' + element.paramKey + '[' + i + ']' + '=' + element.paramValue[i];
              }
            } else if (element.paramValue != null && element.paramValue.constructor.name == 'Object') {
              for (let key in element.paramValue) {
                paramData += '?' + element.paramKey + '[' + key + ']' + '=' + element.paramValue;
              }
            } else {
              paramData += '?' + element.paramKey + '=' + element.paramValue;
            }
          });
        } else {
          params = param
        }
      }

    }
    path = path + '/' + func + paramData
    if (bind) {
      path = func;
    }
    const method: string = methodApi;
    // const funcApi: string = func
    const urlParams: any = {};
    const body: any = {};
    const url = path;
    // console.log('TCL: Download File Request', method, params, funcApi, urlParams, body, url, paramData)
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  public async sfgoDirectApiV2(route, method, param = null, paramTarget = 'url', data = null, config = null, frefixApi = '/api/', newPATH = false, unsubscribe?, unsubscribeKey?, bodyArray?, getData = false, externalUrl = false, externalUrlLink?): Promise<any> {
    // console.log('TCL:Get SFGO sfgoDirectApiV2');

    let setParam = await this.setParam(config, param, paramTarget);
    let setBody = await this.setBody(data, param, paramTarget, bodyArray);
    // console.log('TCL:setBody', setBody);
    return new Promise(async (resolve, reject) => {
      let path = frefixApi + route;

      this.apiServiceProvider.api(method, setParam, setBody, path, null, newPATH, null, null, null, unsubscribe, unsubscribeKey, externalUrl, externalUrlLink).then((response: any) => {
        console.log("GET SFGO", response);

        if (response.hasOwnProperty('isError') && response.isError) {
          reject(
            {
              isError: true,
              data: [],
              message: response.message ? response.message : 'Error !'
            }
          )
        }

        if (getData) {
          if (response.hasOwnProperty('data') && response.data === null) {
            response = {
              data: [],
              message: 'error'
            };
          }
        }
        resolve(response);
      }, error => {
        console.log('Error Get SFGO', error);
        try {
          error = error.json();
          reject(
            {
              isError: true,
              data: [],
              message: error.message ? error.message : 'Error !'
            }
          );
        } catch (error) {
          reject(
            {
              isError: true,
              data: [],
              message: 'Error!'
            }
          );
        }
      });
    });
  }

  /**
   * 
   * @param route 
   * @param method 
   * @param param 
   * @param paramTarget 
   * @param data 
   * @param config 
   * @param frefixApi 
   * @param newPATH 
   * @param paramBody 
   * @param unsubscribe 
   * @param unsubscribeKey 
   * @param externalUrl 
   * @param externalUrlLink 
   * @returns 
   */
  public async cfcDirectApiV2(route, method, param = null, paramTarget = 'url', data = null, config = null, frefixApi = '/builder/cfcDirect', newPATH = false, paramBody?, unsubscribe?, unsubscribeKey?, externalUrl = false, externalUrlLink?): Promise<any> {
    // console.log('TCL:Get SFGO sfgoDirectApiV2',route, method, param, data, paramBody);
    let setParam
    let setBody
    if (paramBody) {
      setBody = {
        "param": param
      }
    } else {
      setParam = await this.setParam(config, param, paramTarget);
      setBody = await this.setBody(data, param, paramTarget);
    }
    // console.log('TCL:setBody', setBody);
    return new Promise(async (resolve, reject) => {
      let path = frefixApi;

      this.apiServiceProvider.api(method, setParam, setBody, path, null, newPATH, null, true, route, unsubscribe, unsubscribeKey, externalUrl, externalUrlLink).then((response: any) => {
        if (response.hasOwnProperty('isError') && response.isError) {
          reject(
            {
              isError: true,
              data: [],
              message: response.message ? response.message : 'Error !'
            }
          )
        }

        resolve(response);
      }, error => {
        console.log('Error Get CFC', error);
        try {
          error = error.json();
          reject(
            {
              isError: true,
              data: [],
              message: error.message ? error.message : 'Error !'
            }
          );
        } catch (error) {
          reject(
            {
              isError: true,
              data: [],
              message: 'Error!'
            }
          );
        }
      });
    });
  }

  public async externalDirectApi(route, method, param = null, paramTarget = 'url', data = null, useLocalStorage = null, config = null, externalUrl = false, externalUrlLink?) {

    let setParam = await this.setParam(config, param, paramTarget);
    let setBody = await this.setBody(data, param, paramTarget);

    if (useLocalStorage) {
      setBody = await this.setFromLocalStorage(setBody);
    }

    let setUri = route + '?' + setParam;

    return new Promise(async (resolve, reject) => {
      const headerOptions: Headers = new Headers({
        'Authorization': LoopBackConfig.getAuthPrefix() + this.SFGoAuth.id,
      });
      const options: RequestOptions = new RequestOptions({ headers: headerOptions });

      if (method == 'GET') {
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        if (externalUrl) {
          headers.append('external-url', externalUrlLink);
        }
        this.http.get(setUri, options).map(data => data.json())
          .subscribe((result: any) => {
            resolve(result);
          }, error => {
            reject(error);
          });
      } else if (method == 'POST') {
        this.http.post(setUri, setBody, options).map(data => data.json())
          .subscribe((result: any) => {
            resolve(result);
          }, error => {
            reject(error);
          });
      }
    });
  }

  private setFromLocalStorage(data): Promise<any> {
    return new Promise(async (resolve) => {
      let paramToBody = {};
      for (let key in data) {
        paramToBody[key] = data[key];
        let getValueStorage = await this.storage.get(key);
        if (getValueStorage != null) {
          paramToBody[key] = getValueStorage;
        }
      }

      let bodyData = Object.assign({}, data, paramToBody);
      resolve(bodyData);
    });
  }

  public setParam(config = null, param = null, paramTarget): Promise<any> {
    return new Promise((resolve) => {

      let paramData = '';

      if (config != null) {
        for (let key in config) {
          if (config[key] != undefined && config[key] != null) paramData += '&' + key + '=' + config[key];
        }
      }
      if (param != null && paramTarget == 'url') {
        param.forEach(element => {
          if (element.paramValue != null && element.paramValue.constructor.name == 'Array') {
            for (let i = 0; i < element.paramValue.length; i++) {
              if (element.paramValue != undefined && element.paramValue != null) paramData += '&' + element.paramKey + '[' + i + ']' + '=' + element.paramValue[i];
            }
          } else if (element.paramValue != null && element.paramValue.constructor.name == 'Object') {
            for (let key in element.paramValue) {
              if (element.paramValue != undefined && element.paramValue != null) paramData += '&' + element.paramKey + '[' + key + ']' + '=' + element.paramValue;
            }
          } else {
            if (element.paramValue != undefined && element.paramValue != null) paramData += '&' + element.paramKey + '=' + element.paramValue;
          }
        });
      }
      resolve(paramData);
    });
  }

  public setBody(data = {}, param = null, paramTarget, bodyArray?): Promise<any> {
    return new Promise((resolve) => {
      let paramToBody = {};
      // console.log('paramBody', data, param, paramTarget)

      if (param != null && paramTarget == 'body') {
        param.forEach(element => {
          paramToBody[element.paramKey] = element.paramValue;
        });
      }
      // console.log('paramToBody', paramToBody)
      let bodyData;
      if (!bodyArray) {
        bodyData = Object.assign({}, data, paramToBody);
      } else {
        bodyData = Object.assign([], data);
      }
      resolve(bodyData);
    });
  }

  public async setParamData(paramData: any[]) {
    return new Promise((resolve) => {
      let newParamData = [];
      paramData.forEach(param => {
        let firstChar = param.paramKey.charAt(0);
        if (firstChar == '_') {
          let paramKey = param.paramKey.substring(1);
          let SFGOAuthVal = this.SFGoAuth[paramKey];
          if (SFGOAuthVal.constructor.name == 'Object') {
            newParamData.push({
              'paramKey': param.paramKey,
              'paramValue': JSON.stringify(SFGOAuthVal)
            });
          } else {
            newParamData.push({
              'paramKey': param.paramKey,
              'paramValue': SFGOAuthVal
            });
          }
        } else {
          newParamData.push({
            'paramKey': param.paramKey,
            'paramValue': param.paramValue
          });
        }
      });
      resolve(newParamData);
    });
  }

  base64toBlob(dataURI, type) {

    var byteString = atob(dataURI.split(',')[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);

    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: type });
  }

  makeFileRequestSingle(url: string, params: Array<string>, file: any, options, addtionnalParam?) {
    return new Promise((resolve, reject) => {
      let formData: any = new FormData();
      let xhr = new XMLHttpRequest();
      const fileUpload = this.base64toBlob(file.urlFile, file.type);
      formData.append('file', fileUpload, options.fileName);
      if (addtionnalParam && addtionnalParam.length > 0) {
        for (let i = 0; i < addtionnalParam.length; i++) {
          formData.append(addtionnalParam[i].paramKey, addtionnalParam[i].paramValue);
        }
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200 || xhr.status == 201) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Authorization', this.SFGoAuth.id);
      xhr.send(formData);
    });
  }

  makeFileRequest(url: string, params: Array<string>, files: Array<File>, options, addtionnalParam?, index?) {
    // console.log('TCL:Upload SFGO', url, params, files, options, addtionnalParam);
    return new Promise((resolve, reject) => {
      let formData: any = new FormData();
      let xhr = new XMLHttpRequest();
      if (index != null) {
        formData.append('file', files[index], options)
      } else {
        for (let i = 0; i < files.length; i++) {
          formData.append('file', files[i], options);
        }
      }
      if (addtionnalParam && addtionnalParam.length > 0) {
        for (let i = 0; i < addtionnalParam.length; i++) {
          formData.append(addtionnalParam[i].paramKey, addtionnalParam[i].paramValue);
        }
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200 || xhr.status == 201) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Authorization', this.SFGoAuth.id);
      xhr.send(formData);
    });
  }

  public sfgoUploadAttachment(data: any, objUpload?, urlUpload?, additionalParam?, index?) {
    return new Promise(async (resolve) => {
      // console.log('TCL:Upload SFGO', data, urlUpload);

      let event: any;
      if (data.eventsWebview.path) {
        event = data.eventsWebview.path[0].files;
      } else if (data.eventsWebview.target) {
        event = data.eventsWebview.target.files;
      }

      // let event = data.name;
      await this.getStorage();
      let url = urlUpload + '?access_token=' + this.SFGoAuth.id;
      this.makeFileRequest(url, [], event, data.options, additionalParam, index).then(data => {
        console.log('TCL: RESULT ATTACHMENT SFGo', data);
        resolve(data);
      }, err => {
        console.log('TCL: ERROR ATTACHMENT SFGo', data);
        resolve(err);
      });
    });
  }

  public cfcUploadAttachment(data: any, objUpload: any,) {
    return new Promise((resolve) => {
      this.uploadAttachmentProvider.runUploadSF6(data, objUpload).then(res => {
        // console.log('TCL:TCL:RESULT ATTACHMENT CFC', res);
        resolve(res);
      }, err => {
        let fail = {
          RESULT: false,
          ERRMSG: 'Something when wrong',
          LOCALFILE: data
        };
        resolve(fail);
      });
    });
  }

  pageListLoadContent(pageOption, skip = 0, param = [], body = null): Promise<any> {

    let defineLimit = { paramKey: 'limit', paramValue: pageOption.pageLimit };
    let defineSkip = { paramKey: 'skip', paramValue: skip };

    pageOption.paramData.push(defineLimit);
    pageOption.paramData.push(defineSkip);

    param = param.concat(pageOption.paramData);

    return new Promise((resolve, reject) => {
      if (pageOption.apiSourceGet != null) {
        if (pageOption.apiTypeGet == 'sfgo') {

        } else if (pageOption.apiTypeGet == 'cfc') {
          // console.log('TCL: Get CFC global.ts');
          this.builderServiceApi.cfcDirect(pageOption.apiSourceGet, param, body)
            .subscribe((result) => {
              if (result.constructor.name == 'Array') {
                resolve(result);
              } else {
                reject();
              }
            }, (error) => {
              reject(error);
            });
        } else if (pageOption.apiTypeGet == 'external') {

        }
      }
    })
  }

  filterData(schema, data, schemaDefault?): any {
    // console.log('TCL: data filterData', data);
    // console.log('TCL: schema filterData', schema);
    try {
      if (schema == '' || !schema) return null;
      let regex = /^[a-zA-Z0-9]+$/;
      let result = regex.test(schema);

      if (!result) {
        let splitData = schema.split('.');
        if (splitData[2]) {
          if (splitData[2] && splitData[1] != 'Array[0]') {
            if (data[splitData[0]] && [splitData[1]] && data[splitData[0]][splitData[1]] && data[splitData[0]][splitData[1]][splitData[2]]) {
              return data[splitData[0]][splitData[1]][splitData[2]];
            }
          }
        }


        if (splitData[2] && splitData[1] === 'Array') {
          return data[splitData[0]];
        }

        if (splitData[2] && splitData[1] === 'Array[0]') {
          if (data[splitData[0]][0][splitData[2]][splitData[3]]) {
            // console.log('TCL: splitData Array 3', data[splitData[0]][0][splitData[2]][splitData[3]]);
            return data[splitData[0]][0][splitData[2]][splitData[3]];
          } else if (data[splitData[0]][0][splitData[2]]) {
            // console.log('TCL: splitData Array 2', data[splitData[0]][0][splitData[2]]);
            return data[splitData[0]][0][splitData[2]];
          } else {
            return schemaDefault;
          }
        }
        if (data[splitData[0]] && typeof data[splitData[0]][splitData[1]] == 'number' ||
          data[splitData[0]] && typeof data[splitData[0]][splitData[1]] == 'boolean') {
          data[splitData[0]][splitData[1]] = data[splitData[0]][splitData[1]].toString();
        }
        if (data[splitData[0]] && data[splitData[0]][splitData[1]]) {
          return data[splitData[0]][splitData[1]];
        }
      }

      if (!data) return null;
      if (!schema && !schemaDefault) return null;

      if (data && schema && data[schema] === null || data && schema && data[schema] === undefined) {
        // console.log('TCL: schema default', schemaDefault);
        return schemaDefault ? schemaDefault : null;
      }

      if (schema === 'empty') {
        return schemaDefault ? schemaDefault : null;
      }

      if (data && schema && data[schema] !== null && data[schema] !== undefined) {
        if (data[schema] === 'true') {
          return true;
        }
        if (data[schema] === 'false') {
          return false;
        }
        if (data[schema] === 0) {
          return data[schema];
        }
        if (typeof data[schema] == 'boolean') {
          return data[schema];
        }
        if (typeof data[schema] == 'number' || typeof data[schema] == 'boolean') {
          data[schema] = data[schema].toString();
        }
      }

      return data[schema];
    } catch (error) {
      return schemaDefault ? schemaDefault : data[schema];
    }
  }

  formatDate(data, format) {
    let result;
    if (format === 'ddMMMyyyy') {
      result = moment(data).format('DD MMM YYYY');
      return result;
    }
  }

  replaceAccessToken(name, token): any {
    let result = name.replace(new RegExp('{FILE_TOKEN}', 'g'), token);
    return result;
  }

  async replacePath(name, newPATH = false): Promise<any> {
    // console.log('TCL:TCL:Replace PATH', name, newPATH);
    if (name) {
      await this.getStorage();
      let path = this.oldPATHUrl;
      // if (this.changeURL(newPATH)) path = 'https://api.greatdayhr.com/dev-debug'; //local
      if (this.changeURL(newPATH)) path = this.newPATHUrl;
      let result = name.replace(new RegExp('{PICTURE_PATH}', 'g'), path);
      // console.log('TCL:TCL:Final Replace', result);
      return result;
    }
  }

  async addPATH(name, newPATH = false): Promise<any> {
    if (name) {
      await this.getStorage();
      let path = this.oldPATHUrl;
      // if (this.changeURL(newPATH)) path = 'https://api.greatdayhr.com/dev-debug'; //local
      if (this.changeURL(newPATH)) path = this.newPATHUrl;
      let result = path + name + '?access_token=';
      result = this.addAccessToken(result);
      console.log('TCL:TCL:Final Replace', result);
      return result;
    }
  }

  removePath(name): any {
    let result = name.replace(new RegExp('{PICTURE_PATH}', 'g'), '');
    return result;
  }

  get createAccessToken(): any {
    let accessToken = this.SFGoAuth.id;
    return accessToken;
  }

  addAccessToken(name): any {
    let accessToken = this.SFGoAuth.id;
    let result = name + accessToken;
    return result;
  }

  addPath(name): any {
    let result = this.path + name;
    return result;
  }

  async getMockServerData(route, method, param = null, data = null): Promise<any> {
    // console.log('TCL:Get Mockservice');
    let paramTarget = 'url';
    let config = null;
    let setParam = await this.setParam(config, param, paramTarget);
    // let setBody = await this.setBody(data, param, paramTarget);
    return new Promise((resolve, reject) => {
      this.storage.ready().then(() => {
        this.storage.get('SFGoAuth').then(auth => {
          // let SFGoAuth = JSON.parse(auth);
          // let accessToken = SFGoAuth.id;
          let baseUrl = 'https://demo9873685.mockable.io/';
          // let baseUrl = 'http://demo0676729.mockable.io/';
          // let baseUrl = 'http://demo5553159.mockable.io/';
          // let baseUrl = 'http://demo7136492.mockable.io/';
          let fullUrl = baseUrl + route + '?access_token=' + 'test_token' + setParam;
          this.http.get(fullUrl)
            .subscribe((result: any) => {
              // console.log('TCL:Success Mockservice');
              resolve(result.json());
            },
              error => {
                // console.log('TCL:Error Mockservice', error);
                reject(false);
              })
        });
      });
    });
  }

  changeURL(newPATH): boolean {
    if (newPATH && this.newPATH) {
      return true;
    } else {
      return false;
    }
  }

  checkShowCondition(schema, value, auth?) {
    let showTemp: boolean = false;
    let beforeCondition: boolean = false;
    if (schema.hasOwnProperty('conditionAsParam') && schema.conditionAsParam && value) {
      let conditionParamData = schema.conditionParamData;
      if (conditionParamData.length > 0) {
        conditionParamData.forEach(element => {
          if (element.paramCondition == 'or') {
            if (element.hasOwnProperty('paramCondition')) {
              element.paramConditionValue = 'eq';
              if (element.paramValue.charAt(0) === '!') {
                element.paramConditionValue = 'neq';
              }
              if (element.paramConditionValue == 'eq') {
                beforeCondition = (element.paramValue == this.filterData(element.paramKey, value)) ? true : false;
                if (beforeCondition) {
                  showTemp = true
                }
              } else if (element.paramConditionValue == 'neq') {
                beforeCondition = (element.paramValue != this.filterData(element.paramKey, value)) ? true : false;
                if (beforeCondition) {
                  showTemp = true
                }
              }
            } else {
              beforeCondition = (element.paramValue == this.filterData(element.paramKey, value)) ? true : false;
              if (beforeCondition) {
                showTemp = true
              }
            }
          } else if (element.paramCondition == 'and') {
            if (element.hasOwnProperty('paramCondition')) {
              element.paramConditionValue = 'eq';
              if (element.paramValue.charAt(0) === '!') {
                element.paramConditionValue = 'neq';
              }
              if (element.paramConditionValue == 'eq') {
                showTemp = (element.paramValue == this.filterData(element.paramKey, value)) ? true : false;
              } else if (element.paramConditionValue == 'neq') {
                showTemp = (element.paramValue != this.filterData(element.paramKey, value)) ? true : false;
              }
            } else {
              showTemp = (element.paramValue == this.filterData(element.paramKey, value)) ? true : false;
            }
          }
        });
      }
    }

    if (schema.hasOwnProperty('conditionAsAuth') && schema.conditionAsAuth && auth) {
      // console.log('TCL:AUTH');
      let conditionAuthData = schema.conditionAuthData;
      if (conditionAuthData.length > 0) {
        conditionAuthData.forEach(element => {
          // console.log('TCL: ', this.filterData(element.paramKey, auth));
          if (element.paramCondition == 'or') {
            if (element.hasOwnProperty('paramCondition')) {
              element.paramConditionValue = 'eq';
              if (element.paramValue.charAt(0) === '!') {
                element.paramConditionValue = 'neq';
              }
              if (element.paramConditionValue == 'eq') {
                beforeCondition = (element.paramValue == this.filterData(element.paramKey, auth)) ? true : false;
                if (beforeCondition) {
                  showTemp = true
                }
              } else if (element.paramConditionValue == 'neq') {
                beforeCondition = (element.paramValue != this.filterData(element.paramKey, auth)) ? true : false;
                if (beforeCondition) {
                  showTemp = true
                }
              }
            } else {
              beforeCondition = (element.paramValue == this.filterData(element.paramKey, auth)) ? true : false;
              if (beforeCondition) {
                showTemp = true
              }
            }
          } else if (element.paramCondition == 'and') {
            if (element.hasOwnProperty('paramCondition')) {
              element.paramConditionValue = 'eq';
              if (element.paramValue.charAt(0) == '!') {
                element.paramConditionValue = 'neq';
              }
              if (element.paramConditionValue == 'eq') {
                // console.log('TCL:TCL:temp', element.paramValue, this.filterData(element.paramKey, auth));
                showTemp = (element.paramValue == this.filterData(element.paramKey, auth)) ? true : false;
                // console.log('TCL: ', element.paramValue == this.filterData(element.paramKey, auth));
              } else if (element.paramConditionValue == 'neq') {
                showTemp = (element.paramValue != this.filterData(element.paramKey, auth)) ? true : false;
              }
            } else {
              showTemp = (element.paramValue == this.filterData(element.paramKey, auth)) ? true : false;
            }
          }
        });
      }
    }

    return showTemp;
  }

  checkProperty(object, property): boolean {
    if (_.has(object, property)) {
      return true;
    }
    return false;
  }

  checkPropertyTrue(object, property): boolean {
    if (_.has(object, property && object[property])) {
      return true;
    }
    return false;
  }

  checkValueTrue(object, property) {
    if (object[property]) {
      return true;
    }
    return false;
  }

  callFromJson(): Promise<any> {
    return new Promise((resolve) => {
      this.http.get('assets/pagebuilder/dummy/response.json')
        .subscribe((data) => {
          resolve(data.json())
        })
    });
  };

  callPageId(): Promise<any> {
    return new Promise((resolve) => {
      this.http.get('assets/pagebuilder/dummy/pageId.json')
        .subscribe((data) => {
          resolve(data.json())
        })
    });
  };

  uploadMultiple(params: FileTransferOptions) {
    console.log('uploadMultiple');
    return new Promise<{ fileName: string, filePath: string }>((resolve, reject) => {
      let response = {
        fileName: '',
        filePath: ''
      }
      this.fileTransferNative.upload(params)
        .then((result) => {
          console.log('TCL: response Result', result);
          console.log('TCL: doUpload', JSON.parse(result['response']));
          // console.log('TCL: file', result);
          const parse = JSON.parse(result['response']);
          if (parse.data) {
            if (parse.data instanceof Array) {
              response.filePath = parse.data[0].filePath || '';
              response.fileName = parse.data[0].fileName || '';
            } else {
              response.filePath = parse.data.filePath || '';
              response.fileName = parse.data.fileName || '';
            }
          }

          resolve(response);
        }, (error) => {
          console.log('reject', error);
          reject(error)
        });
    })
  }

  handleUploadMultiple(params: { pictures: Array<{ urlFile: string, options: any }>, url: string }) {
    console.log('handleUploadMultiple', params);
    return new Promise((resolve, reject) => {
      let pictureList = [];
      if (params.pictures.length > 0) {
        async.eachOfSeries(params.pictures, async (items, key, callback) => {
          let item = items as any
          let fileName = item.urlFile;
          fileName = fileName.substring(fileName.lastIndexOf('/') + 1, fileName.length);
          fileName = fileName.split('=');

          if (this.platform.is('cordova')) {
            try {
              const data: FileTransferOptions = {
                url: params.url,
                nativeUri: item.urlFile,
                options: item.options
              }
              if (item.options) {
                const result = await this.uploadMultiple(data);
                pictureList.push(result.fileName);
              } else {
                pictureList.push(fileName[1]);
              }
            } catch (error) {
              console.log('error upload', error);
            }
          } else {
            console.log("MAKE FILE REQUEST");
            console.log(params);
            console.log(params.url);
            console.log(item);

            await this.getStorage();
            let url = params.url;
            try {
              if (item.options) {
                let result: any = await this.makeFileRequestSingle(url, [], item, item.options);
                if (result.data) {
                  result = result.data;
                }
                pictureList.push(result.fileName);
              } else {
                pictureList.push(fileName[1]);
              }
            } catch (error) {
              console.log('error upload', error);
            }
          }
          callback();
        }, async (error) => {
          if (error) reject(error);
          resolve(pictureList);
        })
      } else {
        resolve(pictureList)
      }

    })
  }

  componentToHex(c) {
    const hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  rgbToHex(r, g, b) {
    return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
  }

  hexToRgb(hex) {
    try {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? 'rgb(' + parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16) + ')'
        : null;
    } catch (error) {
      return hex;
    }
  }

  recursiveAssign(a, b, c) {
    if (Object(b) !== b) return b;
    if (Object(a) !== a) a = {};
    for (let key in b) {
      console.log(b[key]);
      if (b[key] && b[key].constructor.name === 'Array') {
        a[key] = Object.assign([], b[key]);
        a[key].map(item => {
          return item = this.recursiveAssign({}, item, c);
        });
      } else {
        a[key] = this.recursiveAssign(a[key], b[key], c);
      }
      console.log(a[key]);
    }
    return a;
  }

  getAddress(lat: any, lng: any): Promise<any> {
    return new Promise((resolve) => {
      let geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'latLng': { lat: lat, lng: lng } }, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          if (results[1]) {
            this.ngZone.run(() => {
              resolve(results[1].formatted_address);
            })
          } else {
            resolve('No results found');
          }
        } else {
          resolve('Geocoder failed due to: ');
        }
      });
    })
  }

  async handleStaticChatDynamic(paramDataReturn, schema) {
    paramDataReturn.filterKeyAPI = {
      photo: 'requestByPhoto',
      name: 'requestByName',
      empId: 'requestById',
      category: 'category',
      subtitle: 'status',
      employeeId: 'requestById',
      employeeName: 'requestByName',
      employeePhoto: 'requestByPhoto',
      keyId: 'coachPersonalId',
      keyValue: 'coachPersonalId',

      messageKey: 'followUpId',
      messageImage: 'imageUrl',
      messageText: 'message',
      messageIsRead: 'isRead',
      messageEmployeeId: 'empId',
      messageEmployeeName: 'fullName',
      messageEmployeePhoto: 'photo',
      messageReply: 'respond',
      messageForward: 'forward',
      messageNeedResponse: 'needRespond',
      messageId: 'prevFollowUpId',
      messageDate: 'date'
    }

    paramDataReturn.flagParam = {};
    paramDataReturn.flagParam.defaultDisabledChat = true;
    paramDataReturn.flagParam.updateReadChat = true;
    paramDataReturn.flagParam.isGreeta = true;

    paramDataReturn.employeeId = paramDataReturn[paramDataReturn.filterKeyAPI.employeeId];
    paramDataReturn.employeeName = paramDataReturn[paramDataReturn.filterKeyAPI.employeeName];
    paramDataReturn.employeePhoto = paramDataReturn[paramDataReturn.filterKeyAPI.employeePhoto];

    if (schema.hasOwnProperty('pageStaticKey') && schema.pageStaticKey || schema.hasOwnProperty('pageStaticKey')) {
      if (schema.hasOwnProperty('staticType') && schema.staticType === 'followUp') {
        paramDataReturn.flagParam.defaultHideChat = false;

        // Header
        paramDataReturn.headerEmployeeTitle = paramDataReturn[paramDataReturn.filterKeyAPI.name];
        paramDataReturn.typeChat = 'followUp';
        paramDataReturn.headerStatic = 'Issue';
        paramDataReturn.headerCategory = paramDataReturn[paramDataReturn.filterKeyAPI.category];
        paramDataReturn.headerSubTitle = paramDataReturn[paramDataReturn.filterKeyAPI.subtitle];

        paramDataReturn.headerPhoto = paramDataReturn[paramDataReturn.filterKeyAPI.photo];
        console.log('paramDataReturn.headerPhoto', paramDataReturn.headerPhoto);
        try {
          if (this.SFGoAuth.isSF6) {
            try {
              let imgPath = paramDataReturn.headerPhoto;
              let splitImage = imgPath.split('}');
              let fileName = splitImage[1];

              let path = splitImage[0].substr(1);
              let authPath = this.SFGoAuth[path] ? this.SFGoAuth[path] : '';

              let finalValue = authPath + fileName;
              paramDataReturn.headerPhoto = finalValue;
            } catch (error) {
            }
          } else {
            paramDataReturn.headerPhoto = await this.replacePath(paramDataReturn.headerPhoto, true);
          }
          console.log('paramDataReturn.headerPhoto', paramDataReturn.headerPhoto);
        } catch (error) {
        }

        paramDataReturn.listAPI = {
          getMessage: {
            loopback: '/coaching/viewCoachMessage',
            nestjs: '/coaching/viewCoachMessage',
            param: '&empId=' + paramDataReturn[paramDataReturn.filterKeyAPI.employeeId] + '&' + paramDataReturn.filterKeyAPI.keyId + '=' + paramDataReturn[paramDataReturn.filterKeyAPI.keyValue] + '&type=3'
          },
          sendMessage: {
            loopback: '/coaching/sendResponse',
            nestjs: '/coaching/sendResponse'
          },
          updateReadChat: {
            loopback: '/coaching/updateReadChat',
            nestjs: '/coaching/updateReadChat',
            param: '&empId=' + paramDataReturn[paramDataReturn.filterKeyAPI.employeeId] + '&' + paramDataReturn.filterKeyAPI.keyId + '=' + paramDataReturn[paramDataReturn.filterKeyAPI.keyValue]
          }
        }
      }

      if (schema.hasOwnProperty('staticType') && schema.staticType === 'personalCoachingTeam') {
        paramDataReturn.listAPI = {
          getMessage: {
            loopback: '/coaching/viewCoachMessage',
            nestjs: '/coaching/viewCoachMessage',
            param: '&empId=' + paramDataReturn[paramDataReturn.filterKeyAPI.employeeId] + '&' + paramDataReturn.filterKeyAPI.keyId + '=' + paramDataReturn[paramDataReturn.filterKeyAPI.keyValue] + '&type=2'
          },
          updateReadChat: {
            loopback: '/coaching/updateReadChat',
            nestjs: '/coaching/updateReadChat',
            param: '&empId=' + paramDataReturn[paramDataReturn.filterKeyAPI.employeeId] + '&' + paramDataReturn.filterKeyAPI.keyId + '=' + paramDataReturn[paramDataReturn.filterKeyAPI.keyValue]
          }
        }

        paramDataReturn.typeChat = 'personalCoachingTeam';

        // Header
        paramDataReturn.headerPhoto = paramDataReturn[paramDataReturn.filterKeyAPI.photo];
        console.log('paramDataReturn.headerPhoto', paramDataReturn.headerPhoto);
        try {
          if (this.SFGoAuth.isSF6) {
            try {
              let imgPath = paramDataReturn.headerPhoto;
              let splitImage = imgPath.split('}');
              let fileName = splitImage[1];

              let path = splitImage[0].substr(1);
              let authPath = this.SFGoAuth[path] ? this.SFGoAuth[path] : '';

              let finalValue = authPath + fileName;
              paramDataReturn.headerPhoto = finalValue;
            } catch (error) {
            }
          } else {
            paramDataReturn.headerPhoto = await this.replacePath(paramDataReturn.headerPhoto, true);
          }
          console.log('paramDataReturn.headerPhoto', paramDataReturn.headerPhoto);
        } catch (error) {
        }
        paramDataReturn.headerEmployeeTitle = paramDataReturn[paramDataReturn.filterKeyAPI.name];
        paramDataReturn.headerStatic = 'Issue';
        paramDataReturn.headerCategory = paramDataReturn[paramDataReturn.filterKeyAPI.category];
        paramDataReturn.headerSubTitle = paramDataReturn[paramDataReturn.filterKeyAPI.subtitle];

        paramDataReturn.flagParam.defaultHideChat = true;
      }

      if (schema.hasOwnProperty('staticType') && schema.staticType === 'personalCoaching') {
        console.log("TCL: MASUK personalCoaching");
        paramDataReturn.listAPI = {
          getMessage: {
            loopback: '/coaching/viewCoachMessage',
            nestjs: '/coaching/viewCoachMessage',
            param: '&empId=' + paramDataReturn[paramDataReturn.filterKeyAPI.employeeId] + '&' + paramDataReturn.filterKeyAPI.keyId + '=' + paramDataReturn[paramDataReturn.filterKeyAPI.keyValue] + '&type=1'
          },
          sendMessage: {
            loopback: '/coaching/sendResponse',
            nestjs: '/coaching/sendResponse'
          },
          updateReadChat: {
            loopback: '/coaching/updateReadChat',
            nestjs: '/coaching/updateReadChat',
            param: '&empId=' + paramDataReturn[paramDataReturn.filterKeyAPI.employeeId] + '&' + paramDataReturn.filterKeyAPI.keyId + '=' + paramDataReturn[paramDataReturn.filterKeyAPI.keyValue]
          }
        }

        paramDataReturn.typeChat = 'personalCoaching';
        paramDataReturn.headerPhoto = paramDataReturn[paramDataReturn.filterKeyAPI.photo];
        console.log('paramDataReturn.headerPhoto', paramDataReturn.headerPhoto);
        try {
          if (this.SFGoAuth.isSF6) {
            try {
              let imgPath = paramDataReturn.headerPhoto;
              let splitImage = imgPath.split('}');
              let fileName = splitImage[1];

              let path = splitImage[0].substr(1);
              let authPath = this.SFGoAuth[path] ? this.SFGoAuth[path] : '';

              let finalValue = authPath + fileName;
              paramDataReturn.headerPhoto = finalValue;
            } catch (error) {
            }
          } else {
            paramDataReturn.headerPhoto = await this.replacePath(paramDataReturn.headerPhoto, true);
          }
          console.log('paramDataReturn.headerPhoto', paramDataReturn.headerPhoto);
        } catch (error) {
        }
        paramDataReturn.headerCategory = paramDataReturn[paramDataReturn.filterKeyAPI.category];
        paramDataReturn.headerSubTitle = paramDataReturn[paramDataReturn.filterKeyAPI.subtitle];
        paramDataReturn.headerStatic = '';

        paramDataReturn.flagParam.defaultHideChat = false;
      }
    }
    return paramDataReturn;
  }

  isJsonString(str) {
    try {
      let json = JSON.parse(str);
      return (typeof json === 'object');
    } catch (e) {
      return false;
    }
  }

  removeStorage() {
    this.storage.remove('pageBuilderActive');
    this.storage.remove('cardContents');
    this.storage.remove('valueCardContent');
  }
}



// WEBPACK FOOTER //
// ./src/pagebuilder/providers/global.ts